// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Whyw","clinicsSelect":"styles_clinicsSelect__PoPA5"};